import { render, staticRenderFns } from "./UsuarioPedidoDialog.vue?vue&type=template&id=17ef6334"
import script from "./UsuarioPedidoDialog.vue?vue&type=script&lang=js"
export * from "./UsuarioPedidoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports